import { AnaColumn } from "../forms-template.service";

export const provincia: AnaColumn[] = [
    {
      itemType: "group", colCount: "2", colSpan: "2", data: [
        { type: 'campo', hideOnEdit: true, dataField: "id", dataType: "", caption: "ID" },
        { type: 'campo', dataField: "descrizione", dataType: "", caption: "DENOMINAZIONE" },
        { type: 'campo', dataField: "siglaProvincia", dataType: "", caption: "CAP" },
        { type: 'campo', dataField: "idRegione", dataType: "", caption: "ISTAT" },
        { type: 'campo', dataField: "descrizioneRegione", dataType: "", caption: "PROVINCIA" },
      ]
    },
  ]